import type { IconProps } from './types';

function ClipboardIcon(props: IconProps) {
  const { size = 24, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
    >
      <path d="M15.75 3.5625H20.4375V22.3125H3.5625V3.5625H8.25" stroke={color} strokeWidth="1.5" />
      <path d="M8.25 1.6875H15.75V5.4375H8.25V1.6875Z" stroke={color} strokeWidth="1.5" />
    </svg>
  );
}

export { ClipboardIcon };
